import { BetsCartListener } from '../../../api/connector/cart/BetCart';
import { BetsCartIrmListener } from '~/web-frontend-core/api/connector/cart/BetCartIrm';
import { Base } from '../Base';
// interface with metods
export class BasketCore extends Base {
    constructor(config, isIrm = false) {
        super();
        this.listenerClass = BetsCartListener;
        if (isIrm) {
            this.listenerClass = BetsCartIrmListener;
        }
        this.init(config);
    }
    adapter(data) {
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/core/basket/index.js